import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {FormGroup} from '@angular/forms'

@Component({
  selector: 'dmmp-form-select',
  templateUrl: './select.component.html',
})
export class SelectComponent implements OnInit {
  @Input() field
  @Input() identifier
  @Input() group: FormGroup
  @Input() fieldData
  @Input() formSelects
  @Input() formSelectFilter
  @Output() changeSelect: EventEmitter<any> = new EventEmitter<any>()

  constructor() {
  }

  ngOnInit() {
  }
}
